import { Link } from "react-router-dom";

/**
 * Resumen compacto del comprador para solicitud de licencia (sin recaptura completa).
 */
export default function BuyerProfileSummary({
  profile = {},
  systemInfo = null,
  showCompleteLink = false,
  completeLinkHref = "#config-buyer-profile",
  testId = "buyer-profile-summary",
}) {
  const razon =
    (profile.razon_social || "").trim()
    || (profile.nombre_comercial || "").trim()
    || "—";
  const rfc = (profile.rfc || "").trim().toUpperCase() || "—";
  const email =
    (profile.email || profile.correo_facturacion || "").trim() || "—";
  const telefono = (profile.telefono || "").trim() || "—";
  const installationId = (systemInfo?.installation_id || "").trim() || "—";

  return (
    <div className="rounded-sm border border-slate-200 bg-white px-3 py-2 text-[11px]" data-testid={testId}>
      <dl className="grid sm:grid-cols-2 gap-2 m-0">
        <div className="sm:col-span-2">
          <dt className="text-slate-500">Razón social / nombre</dt>
          <dd className="text-slate-900">{razon}</dd>
        </div>
        <div>
          <dt className="text-slate-500">RFC</dt>
          <dd className="font-mono text-slate-900">{rfc}</dd>
        </div>
        <div>
          <dt className="text-slate-500">Correo de contacto</dt>
          <dd className="text-slate-900">{email}</dd>
        </div>
        <div>
          <dt className="text-slate-500">Teléfono</dt>
          <dd className="text-slate-900">{telefono}</dd>
        </div>
        <div>
          <dt className="text-slate-500">ID instalación</dt>
          <dd className="font-mono text-slate-900 break-all">{installationId}</dd>
        </div>
      </dl>
      {showCompleteLink ? (
        <p className="text-[10px] text-slate-600 mt-2 mb-0">
          <a href={completeLinkHref} className="text-[#0F2D5C] font-semibold underline">
            Completar datos del comprador
          </a>
          {" "}antes de enviar la solicitud.
        </p>
      ) : (
        <p className="text-[10px] text-slate-500 mt-2 mb-0">
          Para cambiar estos datos, actualiza la sección «Datos del comprador» arriba y guarda.
        </p>
      )}
    </div>
  );
}
